module.exports = __webpack_public_path__ + "static/media/tarot-card-7.66cf806b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/tarotcards/tarot-card-7.jpg
// module id = 147
// module chunks = 0